var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _g3, _g4, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _path14, _path15, _path16, _path17, _g5, _path18, _path19, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect3, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle, _path39, _path40, _circle2, _path41, _path42, _path43, _path44, _polygon6, _path45, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _path46, _path47, _path48, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path49, _path50, _path51, _path52, _rect11, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIot401(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.23 22.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-6{fill:#91b3fa;}.cls-3{fill:#bdd0fb;}.cls-16,.cls-17,.cls-4,.cls-44,.cls-54{fill:#fff;}.cls-4{opacity:0.53;}.cls-5{opacity:0.3;}.cls-6{opacity:0.56;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{clip-path:url(#clip-path);}.cls-17{opacity:0.7;}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21,.cls-22{opacity:0.39;}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:url(#linear-gradient-27);}.cls-37{fill:url(#linear-gradient-28);}.cls-38{fill:url(#linear-gradient-29);}.cls-39{fill:url(#linear-gradient-30);}.cls-40{fill:url(#linear-gradient-31);}.cls-41{fill:url(#linear-gradient-32);}.cls-42{fill:url(#linear-gradient-33);}.cls-43{fill:#7d97f4;}.cls-44{opacity:0.8;}.cls-45{fill:url(#linear-gradient-34);}.cls-46{fill:url(#linear-gradient-35);}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{opacity:0.9;}.cls-55{fill:url(#linear-gradient-43);}.cls-56{fill:url(#linear-gradient-44);}.cls-57{fill:url(#linear-gradient-45);}.cls-58{fill:url(#linear-gradient-46);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-48);}.cls-61{fill:url(#linear-gradient-49);}.cls-62{fill:url(#linear-gradient-50);}.cls-63{fill:url(#linear-gradient-51);}.cls-64{fill:url(#linear-gradient-52);}.cls-65{fill:url(#linear-gradient-53);}.cls-66{fill:url(#linear-gradient-54);}.cls-67{fill:url(#linear-gradient-55);}.cls-68{fill:url(#linear-gradient-56);}.cls-69{fill:url(#linear-gradient-57);}.cls-70{fill:url(#linear-gradient-58);}.cls-71{fill:url(#linear-gradient-59);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.02,
    y1: 19.5,
    x2: 11.35,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.63,
    y1: 2.09,
    x2: 7.63,
    y2: 49.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 12.46,
    y1: 10.3,
    x2: 11.61,
    y2: 18.96,
    gradientTransform: "translate(23.24 37.62) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.22,
    y1: 26.92,
    x2: 4.21,
    y2: 18.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 4.22,
    y1: 27.36,
    x2: 6.2,
    y2: 18.55,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 10.96,
    y1: 28.88,
    x2: 12.94,
    y2: 20.06,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 11.66,
    y1: 29.04,
    x2: 13.64,
    y2: 20.22,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 14.37,
    y1: 29.64,
    x2: 16.35,
    y2: 20.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.69,16.52a9.9,9.9,0,0,1,0,1.22c-.17.55-.59.31-1.17.32H3.69c-1,.13-1.15-.33-1.11-1.14l-.09-2V13.06l0-1.39-.1-3.33A1.22,1.22,0,0,1,3.55,7l4.68.1,11.07.35c.69,0,1.44.06,1.51,1.22l-.06,5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 7.07,
    y1: 15.81,
    x2: 5.14,
    y2: 16.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 4.77,
    y1: 15.55,
    x2: 2.77,
    y2: 19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -986.42,
    y1: 15.6,
    x2: -988.09,
    y2: 14.12,
    gradientTransform: "translate(991.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -986.95,
    y1: 15.99,
    x2: -987.96,
    y2: 15.09,
    gradientTransform: "translate(991.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -986.19,
    y1: 16.01,
    x2: -987.48,
    y2: 14.87,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 8.14,
    y1: 16.55,
    x2: 7.47,
    y2: 16.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 336.81,
    y1: 81.69,
    x2: 338,
    y2: 81.69,
    gradientTransform: "translate(-334.02 -45.64) rotate(-3.16)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 5.99,
    y1: 15.4,
    x2: 3.76,
    y2: 19.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 335.68,
    y1: 79.94,
    x2: 336.46,
    y2: 79.94,
    gradientTransform: "translate(-334.02 -45.64) rotate(-3.16)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 5.13,
    y1: 14.9,
    x2: 2.9,
    y2: 18.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 4.6,
    y1: 12.74,
    x2: 4.55,
    y2: 15.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 335.14,
    y1: 81.7,
    x2: 332.13,
    y2: 86.94,
    gradientTransform: "translate(-334.02 -45.64) rotate(-3.16)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 602.15,
    y1: -1106.81,
    x2: 601.17,
    y2: -1105.51,
    gradientTransform: "matrix(0.95, -0.3, 0.3, 0.95, -232.21, 1251.9)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 601.4,
    y1: -1106.5,
    x2: 602.57,
    y2: -1106.5,
    gradientTransform: "matrix(0.95, -0.3, 0.3, 0.95, -232.21, 1251.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 600.71,
    y1: -1105.78,
    x2: 601.5,
    y2: -1106.59,
    gradientTransform: "matrix(0.95, -0.3, 0.3, 0.95, -232.21, 1251.9)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 319.07,
    y1: 154.79,
    x2: 319.52,
    y2: 154.48,
    gradientTransform: "translate(-329.68 -99.28) rotate(-6.97)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 6.16,
    y1: 15.71,
    x2: 6.45,
    y2: 15.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 320.48,
    y1: 153.69,
    x2: 317.29,
    y2: 154.22,
    gradientTransform: "translate(-329.68 -99.28) rotate(-6.97)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 6.13,
    y1: 13.71,
    x2: 5.95,
    y2: 14.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 6.48,
    y1: 14.69,
    x2: 7.71,
    y2: 13.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -985.42,
    y1: 18.47,
    x2: -983.63,
    y2: 17.58,
    gradientTransform: "translate(991.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 9.12,
    y1: 18.92,
    x2: 8.1,
    y2: 17.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 7.87,
    y1: 16.85,
    x2: 9.54,
    y2: 16.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 12.52,
    y1: 7.17,
    x2: 15.63,
    y2: 7.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 12.52,
    y1: 8.76,
    x2: 15.63,
    y2: 8.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 13.21,
    y1: 6.05,
    x2: 14.14,
    y2: 6.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 12.73,
    y1: 6.9,
    x2: 12.97,
    y2: 6.9,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -1975.62,
    y1: -55.97,
    x2: -1970.6,
    y2: -50.68,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, -1967.8, -51.15)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 5.04,
    y1: 3.45,
    x2: 3.01,
    y2: 10.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 7.08,
    y1: 7.17,
    x2: 6.62,
    y2: 10.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -1974.25,
    y1: -56.46,
    x2: -1974.83,
    y2: -52.33,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, -1967.8, -51.15)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -1973.84,
    y1: -56.4,
    x2: -1974.41,
    y2: -52.27,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, -1967.8, -51.15)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -1973.42,
    y1: -56.34,
    x2: -1974,
    y2: -52.21,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, -1967.8, -51.15)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -1973,
    y1: -56.28,
    x2: -1973.58,
    y2: -52.16,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, -1967.8, -51.15)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 109.45,
    y1: -642.94,
    x2: 108.52,
    y2: -640.7,
    gradientTransform: "translate(-193.51 629.63) rotate(9.25)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 20.51,
    y1: 13.43,
    x2: 24.3,
    y2: 8.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 14.88,
    y1: 16.17,
    x2: 17.68,
    y2: 22.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a22b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -7872.91,
    y1: 16.15,
    x2: -7870.12,
    y2: 22.9,
    gradientTransform: "matrix(-1, 0, 0, 1, -7853.07, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 17.33,
    y1: 19.57,
    x2: 17.33,
    y2: 16.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 20.45,
    y1: 16.77,
    x2: 20.13,
    y2: 18.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 23.48,
    y1: 17.46,
    x2: 17.96,
    y2: 23.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 20.05,
    y1: 17.82,
    x2: 18.44,
    y2: 22.19,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -8540.37,
    y1: -127.24,
    x2: -8540.68,
    y2: -125.43,
    gradientTransform: "matrix(-1, -0.02, -0.02, 1, -8536.51, -88.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 16.65,
    y1: 16.74,
    x2: 12.23,
    y2: 23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 16.82,
    y1: 16.51,
    x2: 15.21,
    y2: 20.88,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 18.3,
    y1: 15.3,
    x2: 17.84,
    y2: 21.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 17.27,
    y1: 17.83,
    x2: 17.96,
    y2: 15.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 17.31,
    y1: 14.54,
    x2: 17.27,
    y2: 11.31,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 103.11,
    y1: -607.92,
    x2: 103.52,
    y2: -610.25,
    gradientTransform: "translate(-193.51 629.63) rotate(9.25)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 109.39,
    y1: -642.97,
    x2: 108.48,
    y2: -640.75,
    gradientTransform: "translate(-193.51 629.63) rotate(9.25)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 38.44,
    y1: -96.91,
    x2: 38.85,
    y2: -99.24,
    gradientTransform: "translate(-26.09 116.34) rotate(1.75)",
    xlinkHref: "#linear-gradient-45"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.6.92c-.53,1.86-3.48,13.37,2.25,18a.3.3,0,0,0,.48-.16,22.14,22.14,0,0,0-.75-11.4c-1.3-4-1.73-5.84-1.86-6.45A.06.06,0,0,0,2.6.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.32,18.86a.08.08,0,0,1-.07-.05A44.46,44.46,0,0,1,3.07,9.66a29.62,29.62,0,0,1-.38-4.57.09.09,0,0,1,.12,0,.1.1,0,0,1,0,.11,46.5,46.5,0,0,0,2.56,13.6.1.1,0,0,1-.06.11S5.34,18.87,5.32,18.86ZM2.85,5.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.81,16C4.94,14.75.12,10.49,5.87,1.24a.3.3,0,0,1,.56.17c0,1.44-.08,4,.59,5.37,2.08,4.4,1.31,7.55.78,8.86A.67.67,0,0,1,6.81,16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.23,15.91h0a.09.09,0,0,0,0-.12A16.86,16.86,0,0,1,5.14,8.11a15.18,15.18,0,0,1,.22-3.5.09.09,0,0,0-.07-.11.09.09,0,0,0-.1.07A15.29,15.29,0,0,0,5,8.12a17,17,0,0,0,2.2,7.74S7.2,15.9,7.23,15.91Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.83,4.85a.08.08,0,0,1-.06-.08c0-.09,0-.17.05-.26a.08.08,0,0,1,.1-.06h0a.08.08,0,0,1,.05.1,2,2,0,0,0,0,.24.1.1,0,0,1-.09.07ZM16,4.2h0a.07.07,0,0,1,0-.1l.1-.24a.08.08,0,0,1,.11,0,.07.07,0,0,1,0,.1c0,.07-.07.15-.1.23A.08.08,0,0,1,16,4.2Zm.31-.59h0a.07.07,0,0,1,0-.11l.15-.21a.08.08,0,0,1,.11,0s0,.07,0,.11a1.43,1.43,0,0,0-.14.2A.08.08,0,0,1,16.31,3.61Zm.44-.51,0,0a.08.08,0,0,1,0-.11l.2-.17s.09,0,.11,0a.08.08,0,0,1,0,.11l-.19.16A.1.1,0,0,1,16.75,3.1Zm.54-.4a.1.1,0,0,1-.05,0,.08.08,0,0,1,0-.11l.23-.12a.07.07,0,0,1,.1,0,.08.08,0,0,1,0,.1l-.23.12Zm.61-.28a.05.05,0,0,1,0,0,.07.07,0,0,1,0-.09l.25-.07a.08.08,0,0,1,0,.15l-.24.06A0,0,0,0,1,17.9,2.42ZM20.68,3l0,0-.2-.15a.08.08,0,0,1,0-.1.07.07,0,0,1,.11,0l.21.15a.08.08,0,0,1,0,.11A.11.11,0,0,1,20.68,3Zm-2.12-.66a.06.06,0,0,1-.06-.06.09.09,0,0,1,.07-.09h.26a.08.08,0,1,1,0,.16h-.27Zm1.56.3h0l-.23-.1a.08.08,0,1,1,.06-.14l.24.1a.08.08,0,0,1,0,.11A.07.07,0,0,1,20.12,2.59Zm-.89-.27a.09.09,0,0,1-.06-.09.1.1,0,0,1,.09-.07l.26,0h0a.08.08,0,1,1,0,.15l-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.07,3.32l0,0L21,3.21a.08.08,0,0,1,.12-.11l.08.1a.08.08,0,0,1,0,.11A.08.08,0,0,1,21.07,3.32Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.79,5.56a.07.07,0,0,1-.05-.08V5.36c0-.05,0-.08.08-.08s.08,0,.08.08,0,.09,0,.13a.08.08,0,0,1-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.06,8.2l-.1,0a.07.07,0,0,1-.05-.1A.07.07,0,0,1,18,8l.24.06a.08.08,0,0,1,0,.15ZM17.58,8h0l-.23-.11a.08.08,0,0,1,.08-.14l.22.11a.09.09,0,0,1,0,.1A.08.08,0,0,1,17.58,8Zm1,.25a.08.08,0,0,1,0-.15h.24a.08.08,0,0,1,.08.07.07.07,0,0,1-.08.08h-.27ZM17,7.69h0l-.2-.16a.08.08,0,0,1,.1-.12l.19.16s0,.07,0,.11A.08.08,0,0,1,17,7.69Zm2.26.56s-.05,0-.06-.06a.1.1,0,0,1,.07-.09l.24,0a.08.08,0,0,1,.09.06.07.07,0,0,1-.05.09l-.26.05Zm.64-.17A.08.08,0,0,1,19.86,8a.07.07,0,0,1,0-.1l.22-.1a.08.08,0,0,1,.11,0,.08.08,0,0,1,0,.1L20,8.08Zm.58-.31,0,0a.07.07,0,0,1,0-.11l.2-.15a.08.08,0,0,1,.1,0s0,.09,0,.11a1.56,1.56,0,0,1-.2.16Zm.5-.43,0,0a.08.08,0,0,1,0-.11L21.12,7s.07,0,.11,0a.08.08,0,0,1,0,.11c0,.07-.11.13-.17.2A.08.08,0,0,1,21,7.34Zm.4-.53h0a.07.07,0,0,1,0-.1l.12-.22a.07.07,0,0,1,.1,0,.08.08,0,0,1,0,.11l-.12.22A.09.09,0,0,1,21.39,6.81Zm.27-.6h0a.07.07,0,0,1-.05-.09,1.21,1.21,0,0,1,.05-.18V5.87a.08.08,0,0,1,.09-.06.08.08,0,0,1,.06.1V6l-.06.19A.08.08,0,0,1,21.66,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.52,7.24l0,0a.39.39,0,0,0-.08-.1.08.08,0,0,1,0-.11.07.07,0,0,1,.1,0l.08.1a.07.07,0,0,1,0,.1A.06.06,0,0,1,16.52,7.24Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.84,6.4l0,0,.44,0a2,2,0,0,0,.45.42v.43s0,0,0,0l.49.18h0l.28-.34a2.14,2.14,0,0,0,.62,0l.3.32h0L20,7.17s0,0,0,0l0-.44a1.76,1.76,0,0,0,.41-.45h.44s0,0,0,0l.18-.49s0,0,0,0l-.34-.28a2.14,2.14,0,0,0,0-.62L21,4.5a.06.06,0,0,0,0,0L20.81,4l0,0-.44,0a2,2,0,0,0-.45-.42V3.15s0,0,0,0l-.49-.18h0l-.28.34a2.14,2.14,0,0,0-.62,0L18.14,3h0l-.48.23s0,0,0,0l0,.44a2,2,0,0,0-.42.45h-.43s0,0,0,0l-.18.49s0,0,0,0l.34.28a2.14,2.14,0,0,0,0,.62l-.32.3a.06.06,0,0,0,0,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.7,5.7a.53.53,0,0,1,.18-1,.57.57,0,0,1,.36.2.53.53,0,0,1,.12.38.54.54,0,0,1-.59.48Zm.23-.9h-.06a.4.4,0,1,0,.36.44.41.41,0,0,0-.09-.3A.42.42,0,0,0,18.93,4.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.52,6.44l-.13,0h0l0,0-.18-.09h0s0,0,0,0h0a0,0,0,0,1,.05,0,1,1,0,0,0,.23.12A1.24,1.24,0,0,0,20,5.61a.56.56,0,0,0,0-.12,1.24,1.24,0,0,0-2.36-.73.56.56,0,0,0,0,.12,1.23,1.23,0,0,0,0,.54h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0,1.37,1.37,0,0,1,0-.57.56.56,0,0,1,0-.12,1.3,1.3,0,0,1,2.4-.1,1.27,1.27,0,0,1,.08.86.5.5,0,0,1,0,.13,1.27,1.27,0,0,1-.67.73A1.25,1.25,0,0,1,18.52,6.44Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.78,6.17a0,0,0,0,1,0,0V6s0,0,0,0a0,0,0,0,1,.05,0v.11a0,0,0,0,1-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.8,5.8a0,0,0,0,1,0,0,1.17,1.17,0,0,1,.05-.2v0s0,0,.06,0a0,0,0,0,1,0,.06v0a1.18,1.18,0,0,0,0,.2.07.07,0,0,1-.06,0Zm.13-.47h0a.05.05,0,0,1,0-.07A2.26,2.26,0,0,1,13,5s0,0,.07,0a0,0,0,0,1,0,.06,2.14,2.14,0,0,0-.1.22A.07.07,0,0,1,12.93,5.33Zm.25-.43h0a0,0,0,0,1,0-.07l.16-.19a0,0,0,0,1,.07.07,1.3,1.3,0,0,0-.15.18A.06.06,0,0,1,13.18,4.9Zm.34-.36h0a.06.06,0,0,1,0-.07l.21-.15a0,0,0,0,1,.06,0,0,0,0,0,1,0,.06l-.2.14S13.53,4.55,13.52,4.54Zm.42-.26a0,0,0,0,1,0,0,0,0,0,0,1,0-.06l.24-.09a0,0,0,0,1,.06,0,.06.06,0,0,1,0,.06,1,1,0,0,0-.22.09Zm.47-.15,0,0a.05.05,0,0,1,0-.06l.25,0a0,0,0,0,1,.05,0,.07.07,0,0,1,0,0l-.24,0Zm.49,0s0,0,0,0a0,0,0,0,1,.05,0l.25,0a.07.07,0,0,1,0,.06,0,0,0,0,1-.06,0l-.24,0Zm.72.18h0l-.2-.08h0a.06.06,0,0,1,0-.06s0,0,.06,0h0l.21.08a0,0,0,0,1,0,.06S15.64,4.28,15.62,4.27Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.32,8.05s0,0,0-.05,0,0,.06,0l.23,0a.06.06,0,0,1,0,.06.07.07,0,0,1-.06,0l-.24,0ZM14.08,8h0l-.23-.1a0,0,0,0,1,0-.06,0,0,0,0,1,.06,0l.22.1a0,0,0,0,1,0,.06A0,0,0,0,1,14.08,8Zm.72.13s0,0,0,0a0,0,0,0,1,.05,0l.24,0s0,0,0,0,0,.05,0,.05l-.25,0Zm-1.15-.35h0l-.2-.15a0,0,0,0,1,0-.07s0,0,.06,0l.19.14a0,0,0,0,1,0,.07S13.67,7.76,13.65,7.76Zm1.63.29s0,0,0,0a0,0,0,0,1,0,0l.23-.08s.05,0,.06,0a0,0,0,0,1,0,.06l-.23.08Zm.46-.18,0,0a.06.06,0,0,1,0-.07l.21-.12a0,0,0,0,1,.06,0,0,0,0,0,1,0,.07l-.21.13Zm.39-.28h0a0,0,0,0,1,0-.07,1.37,1.37,0,0,0,.17-.17,0,0,0,0,1,.07,0s0,0,0,.06a1,1,0,0,1-.17.18S16.15,7.6,16.13,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.29,7.43h0l-.08-.09a.06.06,0,0,1,0-.07,0,0,0,0,1,.07,0l.07.09s0,0,0,.06A0,0,0,0,1,13.29,7.43Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.48,6.85s0,0,0,0l.29,0a1.18,1.18,0,0,0,.31.28v.3l0,0,.33.12h0l.19-.22a1.4,1.4,0,0,0,.41,0l.21.21h0l.32-.15,0,0,0-.29a1.33,1.33,0,0,0,.28-.3h.31l.13-.33a0,0,0,0,0,0,0l-.23-.19a1.12,1.12,0,0,0,0-.41l.22-.2v0l-.15-.32s0,0,0,0l-.29,0A1.42,1.42,0,0,0,15.51,5V4.67l0,0-.33-.12s0,0,0,0L15,4.76a1.48,1.48,0,0,0-.42,0l-.2-.21h0L14,4.71s0,0,0,0L14,5a1.15,1.15,0,0,0-.28.3h-.32l-.12.33a0,0,0,0,0,0,0l.23.18a1.48,1.48,0,0,0,0,.42l-.21.2s0,0,0,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.71,6.39a.39.39,0,0,1-.19-.12A.37.37,0,0,1,14.45,6a.35.35,0,0,1,.39-.32.36.36,0,0,1,.32.4.34.34,0,0,1-.13.24.35.35,0,0,1-.26.08Zm.16-.61h0a.27.27,0,0,0-.29.23.25.25,0,0,0,.06.2.24.24,0,0,0,.18.09h0A.22.22,0,0,0,15,6.24a.23.23,0,0,0,.1-.17A.27.27,0,0,0,14.87,5.78Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.59,6.9l-.09,0a.8.8,0,0,1-.16-.08h0s0,0,0,0h0a0,0,0,0,1,.06,0l.15.08h0a.75.75,0,0,0,.39,0,.73.73,0,0,0,.21-.06h0a.79.79,0,0,0,.41-.45l0-.08a.81.81,0,0,0-.5-1,.83.83,0,0,0-.62,0,.79.79,0,0,0-.41.45l0,.08a.82.82,0,0,0,0,.35v0l0,0a0,0,0,0,1-.06,0,.86.86,0,0,1,0-.39l0-.08a.89.89,0,0,1,.46-.51.89.89,0,0,1,1.19.44.89.89,0,0,1,.06.6l0,.08A.88.88,0,0,1,14.59,6.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2.27,18.07a.34.34,0,0,0,.34.33H20.8a.33.33,0,0,0,.33-.33l.15-10.46a.57.57,0,0,0-.61-.51L2.89,6.64a.85.85,0,0,0-.62.24A.9.9,0,0,0,2,7.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2.61,17.74a.31.31,0,0,0,.31.32H20.36a.32.32,0,0,0,.32-.32l.14-9.49A.78.78,0,0,0,20,7.49L3,7a.61.61,0,0,0-.61.61Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1.32,
    y: 18.35,
    width: 20.59,
    height: 0.92,
    rx: 0.14,
    transform: "translate(23.24 37.62) rotate(180)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M9.08,11.78c-1-.29-2.21-.7-2.78-.25s-.9,1-1.72.8-.82-.93-1.47-.64a.48.48,0,0,1-.64-.13l-.1-3.29C2.41,7.52,2,6.87,4,7l4.12.22c.09.1.07.11.11.25h.08s1.23.32,1.06,1.25-.79.83,0,1.54S10.11,12.07,9.08,11.78Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M12,14.79c-.2.84-1.23.55-2.17,1.16s0,1.25-1.47,1.25-2.66-.12-2.95.45-2.5-.13-2.21-.93a2.46,2.46,0,0,0-.69-1.9V13.06c.06,0,.3,0,.36,0a3.22,3.22,0,0,0,2,.13,5.94,5.94,0,0,0,2-.93A1.37,1.37,0,0,1,8,12.1c1,.27,1.41.86,2.24,1C11.2,13.19,12.19,14,12,14.79Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M14.48,9.33s-2.16.85-1.73,1.61-.27,1.17.84,1.26,2.88.52,3.46-.21S16.4,8.77,14.48,9.33Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M17.49,17.1h0c0,.19-.23.33-.46.27-1.06-.28-1.36.45-2.76.5s-1.06-.6-2.21-1.2-.61-1.1.74-1.53a7.7,7.7,0,0,1,2.46-.34,3.18,3.18,0,0,0,.62-.06h0a1.22,1.22,0,0,1,1.53.91Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M16.48,13.52s0,.05,0,.08a.82.82,0,0,0,.48.27.87.87,0,0,1,.61.65c0,.13,0,.27,0,.4,0,.46.47.75.88,1l1.58.78c.34.18.7.34.72-.13,0-.24,0-.48,0-.72l0-1.69.09-5.85a.78.78,0,0,0-.82-.76l-1.54,0c-.43,0-2.91-.37-2.69.43a.87.87,0,0,0,.16.26,19.17,19.17,0,0,0,1.22,1.48,3.54,3.54,0,0,1,.53.63,3,3,0,0,1,.26.64,2.56,2.56,0,0,1,.14.87,1,1,0,0,1-.36.77,1.68,1.68,0,0,1-.59.22,1.37,1.37,0,0,0-.56.26A.51.51,0,0,0,16.48,13.52Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 3.23,
    y: 7,
    width: 0.02,
    height: 11.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 6.34,
    y: 7,
    width: 0.02,
    height: 11.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 9.41,
    y: 7,
    width: 0.02,
    height: 11.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 12.43,
    y: 7,
    width: 0.02,
    height: 11.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 15.55,
    y: 7,
    width: 0.02,
    height: 11.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 18.62,
    y: 7,
    width: 0.02,
    height: 11.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -2.19,
    y: 6.62,
    width: 24.02,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -2.19,
    y: 9.05,
    width: 24.02,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -2.19,
    y: 11.43,
    width: 24.02,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -2.04,
    y: 13.83,
    width: 23.99,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -2.04,
    y: 16.25,
    width: 23.99,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -2.04,
    y: 18.63,
    width: 23.99,
    height: 0.02
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M20.54,13.28h0a0,0,0,0,1,0,0v-.77a0,0,0,0,1,0,0h0a0,0,0,0,1,0,.05v.77A0,0,0,0,1,20.54,13.28Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M20.57,11.4h0s0,0,0-.05l0-2.95A.53.53,0,0,0,20.41,8a.76.76,0,0,0-.51-.18l-5.45-.15a0,0,0,0,1,0,0,0,0,0,0,1,0,0l5.45.15a.86.86,0,0,1,.58.2.65.65,0,0,1,.18.48l0,2.95A0,0,0,0,1,20.57,11.4Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.88,
    y: 13.38,
    width: 6.13,
    height: 4.48,
    rx: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "3.57 14.79 3.31 14.77 2.98 15.72 3.41 17.85 3.81 17.79 3.57 14.79"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "5.12 17.7 4.6 15.75 4.3 14.7 3.57 14.79 3.23 15.77 3.69 17.79 5.12 17.79 5.12 17.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "3.31 14.77 3.96 14.67 4.3 14.7 3.57 14.79 3.31 14.77"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "3.45 15.72 3.81 15.61 3.81 15.16 3.63 15.17 3.45 15.72"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "4.11 15.1 4.27 15.06 4.42 15.55 4.18 15.55 4.11 15.1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M6.82,17.28c-.45,0-.35-.67-.34-.7l-.66.52s.06.38.64.55a.65.65,0,0,0,.39,0A.61.61,0,0,1,6.82,17.28Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M7.68,17a.35.35,0,0,0-.36,0,1.13,1.13,0,0,1-.5.25.61.61,0,0,0,0,.37.89.89,0,0,0,.49-.35.07.07,0,0,1,.11,0s.07.06.07.1.08.1.09.07a.78.78,0,0,0,0-.19l.26.23a.12.12,0,0,0,.16,0A1.17,1.17,0,0,0,7.68,17Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4.62,15.57s.64-.3,1.91.64a.43.43,0,0,1,0,.39c-.1.2-.72.7-.84,1.21A11.59,11.59,0,0,1,4,17.88,5.13,5.13,0,0,1,4.62,15.57Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M5.9,15.26l-.3.41a.14.14,0,0,0,0,.14A.37.37,0,0,0,6,16a.2.2,0,0,0,.16-.12l.2-.47Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M4.21,17.27c-.09-.31.64-1,.64-1l-.23-.66S3,16.76,3.5,17.63a.57.57,0,0,0,.25.26A1,1,0,0,1,4.21,17.27Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M4.21,17.22h0c-.1-.31.61-1,.64-1.06h0v0s-.73.73-.64,1c0,0,0,0,0,0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M5.37,17.17s-.89.41-1.13.16l0-.06a1,1,0,0,0-.46.62c.49.28,1.29-.24,1.5-.39a.13.13,0,0,1,.12,0,1.1,1.1,0,0,0,.31,0c.12,0,.31.38.49.24C6.17,17.72,6,17,5.37,17.17Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M6.57,14.65l0,.87-.49,0L6,14.67S6.51,14.44,6.57,14.65Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M6.1,14.84v.45s0,.14.16.09a.51.51,0,0,1,.26-.08.06.06,0,0,1,0,.06,2.51,2.51,0,0,1,0,.41.06.06,0,0,1-.07,0,1.9,1.9,0,0,1-.44-.1s0,0,0-.05-.06-.43-.08-.52S5.78,15,5.73,15s0,0,0,0a.15.15,0,0,1,.07-.24.07.07,0,0,0,0-.09.15.15,0,0,1,.06-.22.21.21,0,0,1,.27,0,.08.08,0,0,0,.08,0,0,0,0,0,1,0,0,.06.06,0,0,0,.08,0,.18.18,0,0,1,.19-.14c.22,0,.28.23.25.38s-.27.13-.4.08a.25.25,0,0,0-.24.07A.08.08,0,0,0,6.1,14.84Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M5.92,15.3s0-.26,0-.31-.22,0-.17.18S5.92,15.3,5.92,15.3Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.56,14.72h0s.16,0,.16-.13a.24.24,0,0,0-.07-.19l-.05,0h0l.06,0a.28.28,0,0,1,.07.2c0,.13-.17.14-.17.14Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M6.31,15.55a.56.56,0,0,1-.46-.31h0a.53.53,0,0,0,.44.3Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 6.28,
    y: 15.52,
    width: 0.12,
    height: 0.06,
    rx: 0.01
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M5.86,14.94s.13-.47.43-.51a.21.21,0,0,0-.17,0,.67.67,0,0,0-.33.52C5.85,15,5.86,14.94,5.86,14.94Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M5.83,14.87c-.16,0-.15.24-.15.24,0,.15,0,.22.07.26a.12.12,0,0,0,.13,0,.14.14,0,0,0,.08-.1.78.78,0,0,1,0-.09S6,14.85,5.83,14.87Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M5.84,14.92a.09.09,0,0,0-.08,0c-.11.23,0,.38.06.39s.08-.3.07-.38S5.87,14.93,5.84,14.92Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M8.27,17.74H5.86c-.05,0-.07.07-.07.12v0H8.37v0C8.37,17.81,8.32,17.74,8.27,17.74Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M9.23,16l-.31,1.8c0,.06,0,.11-.14.1H6.47c-.08,0-.13-.05-.11-.11l.4-1.84a.15.15,0,0,1,.15-.1l2.22.05C9.19,15.89,9.24,15.93,9.23,16Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M7,15.87l-.43,2s0,0-.07,0-.16,0-.11-.11l.4-1.85a.15.15,0,0,1,.15-.1H7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.86,17.17s0,0,0,0l.22-1.06C9.07,16,9,16,9,16H9c.08,0,.13.05.11.11l-.22,1.06A0,0,0,0,1,8.86,17.17Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 14.08,
    cy: 7.17,
    r: 1.55
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M15.63,7H12.52s-.12.89,1.26,3.25a.39.39,0,0,0,.3.18.37.37,0,0,0,.29-.18C15.75,7.92,15.63,7,15.63,7Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M14.1,10.53h0a.38.38,0,0,1-.33-.19A10.07,10.07,0,0,1,12.53,7.6a1.26,1.26,0,0,1,0-.33.7.7,0,0,1,0-.17v0a1.6,1.6,0,0,1,3.19,0,.24.24,0,0,1,0,.09h0a1.74,1.74,0,0,1-.06.45,9.65,9.65,0,0,1-1.19,2.71A.37.37,0,0,1,14.1,10.53ZM12.56,7.14a.75.75,0,0,0,0,.12h0a1.19,1.19,0,0,0,0,.32h0a9.74,9.74,0,0,0,1.2,2.72.33.33,0,0,0,.27.14v0a.36.36,0,0,0,.25-.14,9.62,9.62,0,0,0,1.19-2.69h0a1.24,1.24,0,0,0,.06-.43h0s0-.07,0-.07h0a1.5,1.5,0,0,0-1.5-1.42A1.51,1.51,0,0,0,12.57,7.1v0Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 14.08,
    cy: 7.17,
    r: 0.9
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.08,8.11A.95.95,0,1,1,15,7.17.95.95,0,0,1,14.08,8.11Zm0-1.79a.85.85,0,1,0,.85.85A.85.85,0,0,0,14.08,6.32Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M13.23,6.23h0s0,0,0,0a1.37,1.37,0,0,1,.91-.34h0v0a1.38,1.38,0,0,0-.89.33Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M12.75,7.28a0,0,0,0,1,0,0,1.44,1.44,0,0,1,.21-.73h0v0a1.34,1.34,0,0,0-.21.72S12.76,7.28,12.75,7.28Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M4.1,8.49l4.31.16a.21.21,0,0,0,.21-.19l0-.52a.2.2,0,0,0-.2-.22L4.14,7.55a.2.2,0,0,0-.21.19l0,.54A.2.2,0,0,0,4.1,8.49Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "8.45 8.48 8.48 7.89 4.11 7.72 4.07 8.32 8.45 8.48"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3.19,8.46l1.26,0a.24.24,0,0,0,.23-.33l-.37-.89a.25.25,0,0,0-.21-.15l-.84,0A.23.23,0,0,0,3,7.32l0,.89A.24.24,0,0,0,3.19,8.46Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "4.56 8.34 4.13 7.31 3.19 7.27 3.13 8.28 4.56 8.34"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "8.02 8.38 8.33 8.39 8.35 7.98 8.04 7.96 8.02 8.38"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "7.6 8.36 7.91 8.37 7.93 7.96 7.63 7.95 7.6 8.36"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "7.18 8.34 7.49 8.36 7.52 7.94 7.21 7.93 7.18 8.34"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "6.76 8.33 7.07 8.34 7.1 7.93 6.79 7.92 6.76 8.33"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "6.34 8.31 6.65 8.32 6.67 7.91 6.36 7.9 6.34 8.31"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "5.91 8.3 6.23 8.31 6.25 7.89 5.94 7.88 5.91 8.3"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "5.49 8.28 5.8 8.29 5.83 7.88 5.51 7.87 5.49 8.28"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "5.06 8.27 5.38 8.28 5.4 7.86 5.09 7.85 5.06 8.27"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M11,11l.06,2.49a.34.34,0,0,0,.56.25l1.91-1.38a.33.33,0,0,0-.08-.56l-2-1.11A.33.33,0,0,0,11,11Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.93,16.62H13.3a.16.16,0,0,1,.16.16v.82a.22.22,0,0,1-.22.22h-3.1a.21.21,0,0,1-.21-.21v-1A0,0,0,0,1,9.93,16.62Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.94,17l-.52-.34a0,0,0,0,1,0-.05h.51Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.1,
    y: 16.86,
    width: 1.6,
    height: 0.1,
    rx: 0.02
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.82,
    y: 17.45,
    width: 1.63,
    height: 0.1,
    rx: 0.02
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.1,
    y: 17.16,
    width: 1.1,
    height: 0.1,
    rx: 0.02
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 12.59,
    y: 17.16,
    width: 0.71,
    height: 0.1,
    rx: 0.02
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 11.34,
    y: 17.16,
    width: 1.12,
    height: 0.1,
    rx: 0.02
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 11.85,
    y: 16.86,
    width: 1.36,
    height: 0.1,
    rx: 0.02
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.1,
    y: 17.45,
    width: 0.62,
    height: 0.1,
    rx: 0.02
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M16.81,13l-.21.15a1.94,1.94,0,0,0,.12,1.15c.25.37,1.12-.3,1.12-.3s.49-.08.74-1c.05-.22-.3,0-.69,0S16.81,13,16.81,13Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M15.94,15.39a1.77,1.77,0,0,1,.54-.25c.08,0,.47.09.72.09a4.8,4.8,0,0,1,.95-.1,2,2,0,0,1,.63.25,2.36,2.36,0,0,1,.76,1.31,1.75,1.75,0,0,1-.59.39l-.07,2.49-1.47.75-1.67-.84.06-2.43a2.61,2.61,0,0,1-.58-.34A2.25,2.25,0,0,1,15.94,15.39Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M15.25,16.7s-.71,2,.91,2.79c.34,0,.21-.61.21-.61s-.71-.15-.49-1.8A5,5,0,0,0,15.25,16.7Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M19.51,16.7s.49,2.06-.92,2.79c-.34,0-.21-.61-.21-.61s.58-.28.5-1.8A5,5,0,0,1,19.51,16.7Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 15.72,
    y: 17.45,
    width: 3.22,
    height: 2.18,
    rx: 0.34
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.52,18a.2.2,0,0,1-.16.24.21.21,0,0,1-.24-.18.2.2,0,0,1,.15-.25A.24.24,0,0,1,17.52,18Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M20.35,20.28a6.06,6.06,0,0,0-1.22,0l0,.09L19,20.8a10.12,10.12,0,0,0,1.21.14h.12l0,0A.43.43,0,0,0,20.35,20.28Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M20.39,20.28h0a.43.43,0,0,1,0,.61l0,0A.35.35,0,0,0,20.39,20.28Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M18.89,20.21H19a.3.3,0,0,1,.21.1.38.38,0,0,1,.07.24.23.23,0,0,1-.08.17.22.22,0,0,1-.17.07l-.22,0Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M14,20.23a6.85,6.85,0,0,1,1.23,0l0,.09,0,.47a10,10,0,0,1-1.21.11l-.11,0,0,0A.45.45,0,0,1,14,20.23Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M14,20.24h0a.45.45,0,0,0-.06.62l0,0A.34.34,0,0,1,14,20.24Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M15.5,20.21h-.14a.28.28,0,0,0-.21.1.38.38,0,0,0-.08.23.27.27,0,0,0,.07.18.23.23,0,0,0,.17.07h.22Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M20.46,18.81a.64.64,0,0,0-.93-.27,23,23,0,0,1-4.15,1.64,2.63,2.63,0,0,1,.09.55.53.53,0,0,1,0,.13,19.54,19.54,0,0,0,4.51-1A.78.78,0,0,0,20.46,18.81Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M18.9,20.76a1.24,1.24,0,0,1,.12-.6v0L18.59,20a20.8,20.8,0,0,1-3.44-1.5.63.63,0,0,0-1,.39.74.74,0,0,0,.5.89,16.37,16.37,0,0,0,4.21,1Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M16.48,15.14a.86.86,0,0,0,.87.63.75.75,0,0,0,.8-.64l-.48-.1,0-.53-.72.05v.51Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M17,12.92s-.77,1.49.14,1.85c.65.26,1.05-1,.93-1.32-.19-.53-.31-.46-.31-.46Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M18.05,13.45v0a.25.25,0,0,1,0,.08v-.06Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M18,13.43v0C18.08,13.46,18,13.31,18,13.43Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M18.41,12.52c.41-.09.12,1.18-.49,1s-.9-.33-1-.17-.25.86-.3.5-.1-.94.22-1.08.35.09.47,0a.71.71,0,0,1,.5,0C18,12.92,18.14,12.58,18.41,12.52Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M16.86,13.57s-.14-.2-.2,0,0,.49.1.35A.54.54,0,0,0,16.86,13.57Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot401);
export default __webpack_public_path__ + "static/media/iot4-01.9ff777b40c89635b6245bc0509cdc282.svg";
export { ForwardRef as ReactComponent };